/* Copyright (c) 2018 Backpack Health LLC */
import * as React from 'react';
import * as _ from 'lodash';
import classnames from 'classnames';

import { CardSection } from '../../../../components/card/Card';

import ExpandToggleControl from '../../../../components/ExpandToggleControl';
import { RenderNestedSurveyQuestion } from '../RenderSurveyQuestion';

import './ExpandableNestedQuestion.scss';

interface Props {
  defaultExpanded: boolean;
  onUpdate(response, option): void;
  question: any;
  response: any;
  valueText: string;
}

const ExpandableNestedQuestion = (props: Props) => {
  const { response, question, onUpdate, valueText } = props;
  const [isExpanded, setIsExpanded] = React.useState(props.defaultExpanded);

  return (
    <div>
      <CardSection
        hasBorder={isExpanded}
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
        onClick={() => { setIsExpanded(!isExpanded); }}
      >
        <div className="theme-group base color font-footnote">
          {(!isExpanded && valueText) || question.text}
        </div>

        <ExpandToggleControl isExpanded={isExpanded} onToggle={() => {}} style={{ marginRight: 4 }} />
      </CardSection>

      <div className={classnames('cmp-nestedquestion', { expanded: isExpanded })}>
        <RenderNestedSurveyQuestion
          className="bkgd-color-gsLightest"
          question={question}
          response={response}
          onUpdate={(res, opt) => {
            setIsExpanded(false);
            onUpdate(res, opt);
          }}
        />
      </div>
    </div>
  );
};

export default ExpandableNestedQuestion;
